import React from 'react';
import { useTable, useGlobalFilter, useSortBy, usePagination } from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css';

function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) {
  const count = preGlobalFilteredRows.length;

  return (
    <div className="row mb-3">
      <div className="col-12 col-md-6 col-lg-4">
        <div className="input-group shadow-sm" style={{ borderRadius: '6px', overflow: 'hidden' }}>
          <div className="input-group-prepend">
            <span className="input-group-text bg-white border-right-0 text-muted">
              <i className="fa-solid fa-magnifying-glass"></i>
            </span>
          </div>
          <input
            type="text"
            className="form-control border-left-0"
            value={globalFilter || ''}
            onChange={(e) => setGlobalFilter(e.target.value || undefined)}
            placeholder={`Search ${count} records...`}
            style={{ fontSize: '13px' }}
          />
        </div>
      </div>
    </div>
  );
}

const AdminTable = ({ tableHeaders = [], tableData = [] }) => {
  const data = React.useMemo(() => (tableData.length ? tableData : []), [tableData]);
  const columns = React.useMemo(() => (tableHeaders.length ? tableHeaders : []), [tableHeaders]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize
  } = useTable(
    { columns, data, initialState: { pageSize: 6 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className="container-fluid mt-3 mt-md-4 px-2 px-md-4">
      <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: '10px' }}>
        <div className="card-body p-3 p-md-4">
          {/* Search Input */}
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
          />

          {/* Table */}
          <div className="table-responsive rounded border" style={{ border: '1px solid #e9ecef' }}>
            <table {...getTableProps()} className="table table-hover table-striped mb-0">
              <thead style={{ backgroundColor: '#003366', color: '#ffffff' }}>
                {headerGroups.map((headerGroup, index) => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers.map((column, colIndex) => (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        key={colIndex}
                        className="text-center align-middle"
                        style={{
                          whiteSpace: 'nowrap',
                          padding: '12px 10px',
                          fontSize: '13px',
                          fontWeight: '600',
                          borderBottom: 'none',
                          color: '#ffffff',
                          cursor: 'pointer'
                        }}
                      >
                        {column.render('Header')}
                        <span className="ml-1">{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={i}>
                      {row.cells.map((cell, cellIndex) => (
                        <td
                          {...cell.getCellProps()}
                          key={cellIndex}
                          className="text-center align-middle"
                          style={{
                            verticalAlign: 'middle',
                            padding: '10px 8px',
                            fontSize: '13px'
                          }}
                        >
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          <div
            className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-3 pt-2"
            style={{ gap: '10px' }}
          >
            <div>
              <button
                className="btn btn-sm text-white font-weight-bold mr-2"
                style={{ backgroundColor: '#003366', borderRadius: '4px', padding: '6px 14px' }}
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                <i className="fa-solid fa-chevron-left mr-1"></i> Previous
              </button>
              <button
                className="btn btn-sm text-white font-weight-bold"
                style={{ backgroundColor: '#003366', borderRadius: '4px', padding: '6px 14px' }}
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Next <i className="fa-solid fa-chevron-right ml-1"></i>
              </button>
            </div>
            <span className="text-muted" style={{ fontSize: '13px' }}>
              Page{' '}
              <strong className="text-dark">
                {state.pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
            <div>
              <select
                className="form-control form-control-sm text-white font-weight-bold"
                value={state.pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                style={{ width: '110px', backgroundColor: '#003366', borderRadius: '4px' }}
              >
                {[6, 10, 20, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTable;
